export const DOCUMENT_TYPES = {
  PLANNING: 'planning',
  RESULT: 'result',
};

/* eslint-disable import/no-mutable-exports */
let documentTypeLabels = {};

export function loadDocumentTypes(locales) {
  documentTypeLabels = {
    [DOCUMENT_TYPES.PLANNING]: locales.common.planning,
    [DOCUMENT_TYPES.RESULT]: locales.common.result,
  };
}

export { documentTypeLabels };
export default documentTypeLabels;
